import { useEffect, useState } from "react";
import { Loader2, X, Trophy, Medal, Star, Flag } from "lucide-react";
import api from "@/lib/api";

export default function PlayerModal({ userId, onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;
    setLoading(true);
    api.get(`/players/${userId}`).then((r) => setData(r.data)).catch(() => setData(null)).finally(() => setLoading(false));
  }, [userId]);

  if (!userId) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" onClick={onClose} data-testid="player-modal">
      <div className="bg-[#0B120E] border border-[#00E676]/25 rounded-2xl w-full max-w-lg max-h-[85vh] overflow-hidden flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b border-[#00E676]/15">
          <h3 className="font-black flex items-center gap-2">{data?.name || "Joueur"}{data?.is_official && <Star size={14} className="text-[#FFD700]" />}</h3>
          <button onClick={onClose} data-testid="player-modal-close" className="p-1 rounded-md hover:bg-[#1A2B20]"><X size={18} /></button>
        </div>
        {loading ? (
          <div className="flex justify-center py-16"><Loader2 className="w-7 h-7 animate-spin text-[#00E676]" /></div>
        ) : !data ? (
          <p className="p-6 text-center text-[#697C6F]">Joueur introuvable.</p>
        ) : (
          <div className="overflow-y-auto p-4 space-y-4">
            <div className="grid grid-cols-3 gap-3">
              <div className="rounded-xl border border-[#00E676]/15 bg-[#131F17] p-3 text-center">
                <Trophy size={16} className="text-[#FFD700] mx-auto" />
                <div className="tabular text-xl font-black mt-1">{data.rank ? `#${data.rank}` : "—"}</div>
                <div className="text-[10px] text-[#697C6F]">Classement</div>
              </div>
              <div className="rounded-xl border border-[#39FF14]/25 bg-[#131F17] p-3 text-center">
                <Star size={16} className="text-[#39FF14] mx-auto" />
                <div className="tabular text-xl font-black mt-1">{data.total_points}</div>
                <div className="text-[10px] text-[#697C6F]">Points</div>
              </div>
              <div className="rounded-xl border border-[#00E676]/15 bg-[#131F17] p-3 text-center">
                <Medal size={16} className="text-[#00E676] mx-auto" />
                <div className="tabular text-xl font-black mt-1">{data.plays}</div>
                <div className="text-[10px] text-[#697C6F]">Paris joués</div>
              </div>
            </div>

            <div>
              <h4 className="text-xs uppercase tracking-wide text-[#697C6F] mb-2">Historique de ses favoris</h4>
              {data.history.length === 0 ? (
                <p className="text-sm text-[#697C6F]">Aucun favori couru pour le moment.</p>
              ) : (
                <div className="space-y-2" data-testid="player-history">
                  {data.history.map((h, i) => (
                    <div key={i} className="flex items-center gap-3 rounded-lg bg-[#131F17] border border-[#00E676]/10 px-3 py-2">
                      <span className="tabular w-8 h-8 grid place-items-center rounded-md bg-[#1A2B20] text-white font-black shrink-0">{h.numero}</span>
                      <div className="min-w-0 flex-1">
                        <div className="text-sm font-semibold truncate">{h.cheval || `N°${h.numero}`}</div>
                        <div className="text-[11px] text-[#697C6F] flex items-center gap-1">
                          {h.date} · {h.hippodrome} {h.course}
                          {h.arrivee?.length > 0 && <span className="flex items-center gap-0.5 text-[#39FF14]"><Flag size={10} /> {h.arrivee.slice(0, 5).join("-")}</span>}
                        </div>
                      </div>
                      <span className={`text-xs font-black px-2.5 py-1 rounded-full bg-white shrink-0 ${h.points > 0 ? "text-[#D4AF37]" : "text-black"}`}>+{h.points} pts</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
